import "./TextInput.scss";
import { useState } from "react";
import { AiFillEye } from "react-icons/ai";

const TextInput = ({
  labelText,
  inputType,
  onChangeEvent,
  inputName,
  value,
  visibilityOption,
}) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const handleVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const handleInputType = (inputType) => {
    if (inputType != "password") return inputType;
    if (passwordVisibility) return "text";
    return "password";
  };

  return (
    <div className="text-input">
      <label htmlFor={inputName} className="text-input__label">
        {labelText}
      </label>

      <div className="text-input__container">
        <input
          type={handleInputType(inputType)}
          name={inputName}
          className="text-input__input"
          value={value}
          onChange={onChangeEvent}
          required
        />
        {visibilityOption && (
          <button
            className="text-input__icon-container"
            tabIndex="0"
            type="button"
            onClick={handleVisibility}
          >
            <AiFillEye
              onClick={handleVisibility}
              className="text-input__icon"
            ></AiFillEye>
          </button>
        )}
      </div>
    </div>
  );
};

export default TextInput;
